export default "__VITE_ASSET__B_Z_yxSi__"